module.exports = __webpack_public_path__ + "media/newstyle/images/headphones-bfdceb51b40dbeffce8cb58fbfd85f58.svg";